import Navigator from './components/Navigation';
import './style.css';
import './workDetailPage/style_works.css';
import './font.css';
import { Waiting } from './components/Waiting';
import {WorkTitle} from './workDetailPage/WorkTitle';
import mainImage from './image/works/work7MainImage.webp';
import { WorkTextSection } from './workDetailPage/WorkTextSection';
import { AnimationOnScroll } from 'react-animation-on-scroll';
import work1chart1 from './image/works/work1chart1.webp';
import { Dispatch, SetStateAction, useEffect } from 'react';
import wavedivider from './image/wavedivider.webp'
import { MainImage } from './workDetailPage/WorkMainImage';
import BackButton from './components/BackButton';
import NextItem from './components/NextItem';
import thumbnail6 from './image/workThumbnails/thumbnail6.webp';
import goal from './image/works/work7goal.webp';
import goalKor from './image/works/work7goalkor.webp';
import background from './image/works/work7background.webp';
import needs from './image/works/work7needs.webp';
import needsKor from './image/works/work7needskor.webp';
import feature1 from './image/works/work7feature1.webp';
import feature1Kor from './image/works/work7feature1kor.webp';
import feature2 from './image/works/work7feature2.webp';
import feature2Kor from './image/works/work7feature2kor.webp';
import feature3 from './image/works/work7feature3.webp';
import feature3Kor from './image/works/work7feature3kor.webp';
import feature4 from './image/works/work7feature4.webp';
import feature4Kor from './image/works/work7feature4kor.webp';
import structure from './image/works/work7structure.webp';
import structureKor from './image/works/work7structurekor.webp';
import design1 from './image/works/work7design1.webp';
import design1Kor from './image/works/work7design1kor.webp';
import design2 from './image/works/work7design2.webp';
import design2Kor from './image/works/work7design2kor.webp';
import design3 from './image/works/work7design3.webp';
import design3Kor from './image/works/work7design3kor.webp';
import design4 from './image/works/work7design4.webp';
import design5 from './image/works/work7design5.webp';
import design6 from './image/works/work7design6.webp';
import FeedURLUpload1 from './image/works/work7FeedURLUpload1.webp';
import FeedURLUpload1Kor from './image/works/work7FeedURLUpload1kor.webp';
import FeedURLUpload11 from './image/works/work7FeedURLUpload11.webp';
import FeedURLUpload11Kor from './image/works/work7FeedURLUpload11kor.webp';
import FeedURLUpload2 from './image/works/work7FeedURLUpload2.webp';
import FeedURLUpload2Kor from './image/works/work7FeedURLUpload2kor.webp';
import firstUserScenario from './image/works/work7firstUserScenario.webp';
import firstUserScenarioKor from './image/works/work7firstUserScenariokor.webp';
import UploadHistory1 from './image/works/work7UploadHistory1.webp';
import UploadHistory1Kor from './image/works/work7UploadHistory1kor.webp';
import UploadHistory2 from './image/works/work7UploadHistory2.webp';
import UploadHistory2Kor from './image/works/work7UploadHistory2kor.webp';
import UploadHistory3 from './image/works/work7UploadHistory3.webp';
import UploadHistory3Kor from './image/works/work7UploadHistory3kor.webp';
import productset1 from './image/works/work7productset1.webp';
import productset1Kor from './image/works/work7productset1kor.webp';
import productset2 from './image/works/work7productset2.webp';
import productset2Kor from './image/works/work7productset2kor.webp';
import productset3 from './image/works/work7productset3.webp';
import productset3Kor from './image/works/work7productset3kor.webp';
import productset4 from './image/works/work7productset4.webp';
import productset4Kor from './image/works/work7productset4kor.webp';
import work7productsetmanaging1 from './image/works/work7productsetmanaging1.webp';
import work7productsetmanaging1Kor from './image/works/work7productsetmanaging1kor.webp';
import result from './image/works/work7Result.webp';
import result2 from './image/works/work7Result2.webp';
import { WorkFullImage } from './workDetailPage/WorkFullImage';
import { Divider } from '@mui/material';
import ImageTabs, { ImageTab } from './components/ImageTabs';
import { WorkImage } from './workDetailPage/WorkImage';
import { useMetaTags } from './utils/useMetaTags';
import { useLanguage } from './contexts/LanguageContext';
//CatalogManager

const imageTabData: ImageTab[] = [
  { id: 'Catalog Manager', label: 'Catalog Manager', imageUrl: design4 },
  { id: 'Product Set', label: 'Product Set', imageUrl: design5 },
  { id: 'Upload History', label: 'Upload History', imageUrl: design6 },
];

function Work7(props: {
  activeNav: number, 
  setActiveNav: Dispatch<SetStateAction<number>>,
}) {
    const { language } = useLanguage();
    
    useMetaTags({
      title: 'New Catalog Manager for Ads - Lynkim',
      description: 'Design a catalog management platform that can manage and advertise millions of products for Karrot.',
      image: '/ogimage.png',
    });
    
    // 언어에 따라 이미지 선택하는 함수
    const getImage = (imageName: string, korImage: string): string => {
      return language === 'ko' ? korImage : imageName;
    };
    
    return (
      <>

      <Navigator activeNav={props.activeNav} setActiveNav={props.setActiveNav} />
      <div className='fadeIn '>
        <WorkTitle 
          title={'New Catalog Manager for Ads'} 
          description={'Design a catalog management platform that can manage and advertise millions of products for Karrot.'} 
          team={'Karrot(Daangn)'} 
          role={'User Research, Service Planning, UXUI Design'} 
          period={'2024.01. - 2024.06.'}
          titleKo={'광고용 신규 카탈로그 매니저'}
          descriptionKo={'수백만 개의 상품을 관리하고 광고할 수 있는 카탈로그 관리 플랫폼을 설계했습니다.'}
          teamKo={'당근마켓(Karrot)'}
          roleKo={'사용자 리서치, 서비스 기획, UXUI 디자인'}
        />
      </div>
      <MainImage image={mainImage}/>
      <WorkTextSection 
          title={'Background'} 
          description={<div>
              Karrot's catalog management platform was newly launched in the first half of 2023. Through the catalog platform, we were able to display related new product ads below secondhand trading products, generating revenue from new product ads. However, the problem of low ad click-through rates (CTR) persisted because displayed product ads were not highly relevant to secondhand trading products.
              <br/>To display more relevant ads on ad space, we first needed to have more ad products available for exposure. However, the current catalog platform had limitations in attracting shopping mall advertisers with large product inventories because it could only manage and advertise up to 300 products per catalog.
              <br/>Therefore, we decided to develop a catalog management platform capable of registering, managing, and advertising millions of products.
            </div>}
          subDescription={<div>
              당근의 카탈로그 관리 플랫폼이 2023년 상반기에 새롭게 출시되었습니다. 카탈로그 플랫폼을 통해, 중고거래 상품 하단에 관련된 새로운 상품 광고를 노출할 수 있게 되었고, 새상품 광고로 매출을 만들어냈습니다. 하지만 노출되는 상품광고가 중고거래 상품과 연관성이 높지 않은 문제로 광고 클릭률(CTR)이 매우 낮은 문제가 지속적으로 제기 되었습니다. <br/> 
              연관성이 있는 광고가 노출되기 위해서는 먼저 노출이 가능한 상품을 많이 갖고 있어야 했지만, 이는 현재의 카탈로그 플랫폼이 카탈로그당 최대 300개 제품만 관리하고 광고할 수 있는 제한으로 인해, 대규모의 상품을 갖고 있는 쇼핑몰을 광고주로 영입하지 못하는 한계에 원인이 있었습니다.
              <br/>따라서 수백만 개의 상품을 등록하고, 관리 및 광고할 수 있는 카탈로그 관리 플랫폼 개발에 착수하는 것으로 결정했습니다.
            </div>}
        />
      <WorkFullImage image={background} isBackgroundColor={true} isRoundedCorner={true} isMargin={true} description='Product ads that are not relevant enough to the context and thus fail to entice users to click.'/>
      <WorkTextSection 
          title={'Goal'} 
          description={<div>
              To display more relevant ads on ad space, we first needed to have more ad products available for exposure. Therefore, we aimed to create Karrot's unique catalog management platform capable of managing and advertising millions of products, securing shopping mall advertisers with large product inventories.
            </div>}
          subDescription={<div>
              광고지면에 더 연관성 있는 광고가 노출되기 위해서는 노출 가능한 더 많은 광고 상품 수를 갖추는 것이 선행되어야 합니다. 따라서 수백만 개의 상품을 관리하고 광고할 수 있는 당근 만의 카탈로그 관리 플랫폼을 제작하여, 대규모 상품을 보유한 쇼핑몰 광고주들을 확보하는 목표를 가졌습니다. 
            </div>}
        />
      <WorkFullImage image={getImage(goal, goalKor)} />
      <WorkTextSection 
          title={'User Needs'} 
          description={<div>
              We conducted research on the essential features a catalog management platform must have when dealing with shopping malls that sell millions of products. Through interviews with large shopping malls such as 11st and Naver Shopping, and analysis of UX from other catalog management platforms, we identified the essential requirements for catalog management platforms as follows.
            </div>}
          subDescription={<div>
              수백만 개의 제품을 판매하는 쇼핑몰이 사용할 수 있는 카탈로그 관리 플랫폼이 반드시 가져야 할 핵심 기능에 대한 연구를 진행했습니다. 11번가, 네이버 쇼핑 등의 규모있는 쇼핑몰과의 인터뷰 및 타 카탈로그 관리 플랫폼의 UX를 분석하여, 아래와 같이 카탈로그 관리 플랫폼의 필수 요구사항을 확인했습니다. 
            </div>}   
        />
      <WorkImage image={getImage(needs, needsKor)} isMaxheight={false} isbottomPadding={false} />
      <WorkTextSection 
          title={'Key Features'} 
          description={'To meet the requirements of shopping malls that sell a large volume of products, we planned to develop an MVP with the minimum must-have features.'}
          subDescription={'대량의 제품을 판매하는 쇼핑몰의 요구사항을 충족하기 위해 최소 필수 기능을 갖춘 MVP 개발을 계획했습니다.'}
          />
      <div style={{ maxWidth: "1400px", display: "flex", flexDirection: "row", gap:"12px", margin:"auto", paddingLeft:"48px", paddingRight:"48px", alignContent: "center", marginBottom:'60px'}}>
          <WorkFullImage image={getImage(feature1, feature1Kor)} isRoundedCorner={true} isShadow={true} isBorder={true}/>     
          <WorkFullImage image={getImage(feature2, feature2Kor)} isRoundedCorner={true} isShadow={true} isBorder={true}/>   
          <WorkFullImage image={getImage(feature3, feature3Kor)} isRoundedCorner={true} isShadow={true} isBorder={true}/>     
          <WorkFullImage image={getImage(feature4, feature4Kor)} isRoundedCorner={true} isShadow={true} isBorder={true}/>      
        </div>
      <WorkTextSection 
          title={'Structure'} 
          description={'First, we restructured the catalog manager to allow users to create product sets. To facilitate managing large volumes of products, we added filter functionality enabling users to easily identify product items that match specific criteria, and added a Feed URL upload method to the existing product upload method.'}
          subDescription={'먼저 사용자가 상품 세트를 생성할 수 있도록 카탈로그 매니저를 재구성했습니다. 대량의 상품 관리를 용이하게 하기 위해 필터 기능을 추가하여 사용자가 특정 조건에 맞는 상품 항목을 쉽게 식별할 수 있도록 했으며, 기존 상품 업로드 방식에 Feed URL 업로드 방식을 추가했습니다.'}
      />
      <WorkImage image={getImage(structure, structureKor)} isMaxheight={false} isbottomPadding={false} />
      <Divider/>
      <WorkTextSection title={'Overview'}/>
      <WorkFullImage image={getImage(design1, design1Kor)}/>
      <WorkFullImage image={getImage(design2, design2Kor)}/>
      <WorkFullImage image={getImage(design3, design3Kor)}/>
       {/* <ImageTabs tabs={imageTabData} defaultTabId='Catalog Manager' /> */}
      <Divider/>
      <WorkTextSection title={'First User Scenario'}
        description={
          <div>
            From small advertisers to large-scale shopping malls, we designed the onboarding flow so that first-time users can easily understand the catalog operation method and naturally proceed to the next task, selecting the most suitable upload method.
          </div>
        }
        subDescription={
          <div>
            소규모 광고주부터 대규모 쇼핑몰까지, 첫 사용자가 카탈로그를 쉽게 이해하고 가장 적합한 업로드 방법을 선택할 수 있도록 온보딩 플로우를 설계했습니다. 쉽게 카탈로그 운영방식에 대해 이해하면서, 다음 과업으로 자연스럽게 넘어갈 수 있도록 플로우와 가이드를 설계했습니다.
          </div>
        }/>
      <WorkFullImage image={getImage(firstUserScenario, firstUserScenarioKor)}/>
      <Divider/>
     <WorkTextSection title={'Feed URL Upload'}
        description={<div>
          We designed a new product upload method called <b>"Feed URL Upload"</b> specifically for large-sized shopping malls that handle a high volume of products.
          <br/>
          Unlike the previous method, which required sellers to manually input products one by one, this new method eliminates the need for manual entry. Instead, managers can simply input the URL of a product feed table they already manage. This is a format used by other advertising platforms such as Naver EP or Meta product feeds, so it is very familiar to large shopping mall ad specialists.
          <br/>
          This allows for efficient bulk uploads and enables automatic product data updates according to the mall's preferred schedule, greatly reducing manual workload and keeping data continuously up-to-date.
      </div>}
      subDescription={<div>
        대량의 상품을 관리하는 대규모 쇼핑몰을 위해 <b>"피드 URL 업로드"</b>라는 새로운 상품 업로드 방법을 설계했습니다.
        <br/>
        판매자가 상품을 하나씩 수동으로 입력하여 업로드했던 기존 방법과 달리, 이 새로운 방법은 수동 입력할 필요없이, 데이터 URL을 입력하는 방식으로 빠르게 대량의 상품을 업로드하고, 자동으로 상태를 주기적으로 업데이트할 수 있습니다. 관리자는 이미 플랫폼에서 관리하고 있는 제품 피드 테이블의 URL만을 입력하면 됩니다. 이는 네이버 EP나 메타 제품 피드 등 다른 광고 플랫폼에서 사용하는 형식이기 때문에, 대규모 쇼핑몰 광고 전문가에게는 매우 익숙한 방식입니다. 
        <br/>
        이를 통해 효율적인 대량 업로드가 가능하고 쇼핑몰의 선호 일정에 따라 자동으로 상품의 데이터가 업데이트되어 수동 작업량을 크게 줄이고 데이터를 지속적으로 최신화 할 수 있습니다.
    </div>}/>
      
      <WorkFullImage image={getImage(FeedURLUpload1, FeedURLUpload1Kor)} />
      <WorkFullImage image={getImage(FeedURLUpload11, FeedURLUpload11Kor)} isBackgroundColor={true}/>
      <Divider/>
      <div style={{background: 'linear-gradient(180deg, rgba(242, 243, 246, 0.00) 0%, var(--color-bg-soft-cool) 100%)'}}>
        <WorkTextSection title='Upload validation process'
          description={<div>When the upload is complete, the system checks for any issues with the Feed URL. <br/>Then, we provide a guide for users to pre-check and correct any errors.</div>}
          subDescription={<div>업로드가 완료되면 시스템이 피드 URL에 문제가 있는지 확인합니다. <br/>그런 다음 사용자가 미리 확인하고 오류를 수정할 수 있도록 가이드를 제공합니다.</div>}/>
        <WorkFullImage image={getImage(FeedURLUpload2, FeedURLUpload2Kor)}  />
      </div>
      <div style={{background: 'linear-gradient(180deg, var(--color-bg-soft-cool)  0%, rgba(242, 243, 246, 0.00) 100%)'}}>
        <WorkTextSection title={'Upload History & Error report'} 
          description={<div>
            With the newly introduced Feed URL Upload method, advertisers can now automatically update a large volume of products with minimal manual effort.
            <br/>To support this, we made it easy to check whether all product data updates were successfully applied without errors.
            <br/>In case any issues occur, advertisers can review detailed error information and download the full error report for further inspection and resolution.
          </div>}
          subDescription={<div>
            새로 도입된 피드 URL 업로드 방법으로 광고주는 이제 최소한의 수동 작업으로 대량의 제품을 자동으로 업데이트할 수 있습니다.
            <br/>이를 지원하기 위해 모든 제품 데이터 업데이트가 오류 없이 성공적으로 적용되었는지 쉽게 확인할 수 있도록 했습니다.
            <br/>문제가 발생할 경우 광고주는 상세한 오류 정보를 검토하고 추가 검사 및 해결을 위해 전체 오류 보고서를 다운로드할 수 있습니다.
          </div>}/>
        <WorkFullImage image={getImage(UploadHistory1, UploadHistory1Kor)}/> 
        <WorkFullImage image={getImage(UploadHistory2, UploadHistory2Kor)} isBottomMargin={true}/> 
        <WorkFullImage image={getImage(UploadHistory3, UploadHistory3Kor)}/> 
      </div>
      <Divider/>
      <WorkTextSection title={'Product Set'} description={
        <div>
          To advertise products registered in the catalog, users must first create a product set and then link that set to an ad group.
          <br/>
          Product sets can be created either by <b>manually selecting individual products</b> (existing method) or <b>by applying filters to automatically include products that meet certain conditions</b> (new method).
        </div>
      }
      subDescription={
        <div>
          카탈로그에 등록된 상품을 광고하려면 사용자는 먼저 상품세트를 생성한 다음 해당 세트를 선택하여 광고그룹에 연동해야 합니다.
          <br/>
          상품세트는 <b>개별 상품을 수동으로 선택</b>하거나(기존 방식) <b>특정 조건을 충족하는 상품을 자동으로 포함하도록 필터를 적용</b>(새로운 방식)하여 생성할 수 있습니다.
        </div>
      }/>
      <WorkFullImage image={getImage(productset1, productset1Kor)} />
      <WorkFullImage image={getImage(productset2, productset2Kor)} isBottomMargin={true}/>
      
      <WorkFullImage image={getImage(productset3, productset3Kor)} isBottomMargin={true} isBackgroundColor={true}
      // isRoundedCorner={true} isShadow={true} isMargin={true} isBorder={true}
      />
      
      <WorkFullImage image={getImage(productset4, productset4Kor)} isBottomMargin={true}/>
      <Divider/>
      <WorkTextSection title='Linking a product set to an ad group'
        description={
          <div>
            When creating an ad campaign, linking a catalog product set to an ad group allows users to see how many ad groups are connected to that product set. It also makes it easier to find and check the status of linked ad groups for management.
          </div>
        }
        subDescription={
          <div>
            광고 캠페인을 생성할 때 카탈로그 상품세트를 광고그룹에 연결하면 사용자가 해당 상품세트에 연결된 광고그룹이 몇 개인지 확인할 수 있습니다. 또한 연동된 광고그룹을 찾아 쉽게 상태를 확인하고 관리할 수 있습니다.
          </div>
        }/>
      <WorkFullImage image={getImage(work7productsetmanaging1, work7productsetmanaging1Kor)} isBottomMargin={false}/>
      <WorkTextSection title='Result' description={
        <div>
          After launching the catalog platform, we successfully onboarded major shopping mall advertisers, securing registered and active product numbers. This led to approximately a <b>2.5x increase</b> in the number of exposed products, overcoming previous limitations in growing product ads.
          <br/>We continue to see explosive growth in product inventory, driving a steady upward trend in key advertising metrics, including impressions, clicks, CTR, and eCPM.
          </div>
      }
      subDescription={
        <div>
          카탈로그 플랫폼을 런칭한 후, 대형 쇼핑몰 광고주를 입점시켜 등록 및 활성화된 상품 수를 확보했습니다. 이에 따라 기존의 상품광고를 성장시키는데 한계였던 노출되는 상품 수를 <b>2.5배 가량</b> 증가시킬 수 있었습니다.  
          현재에도 상품 수를 폭발적으로 성장시키고 있으며, 지속적으로 광고 상품의 노출 및 클릭 수, CTR과 eCPM 등 연관된 광고 지표 또한 꾸준히 성장해나가고 있습니다.
          </div>
      }/>
      <WorkImage image={result} isMaxheight={true} isbottomPadding={true} />
      <WorkImage image={result2} isMaxheight={true} isbottomPadding={false} />
      {/* <Waiting/> */}
      <BackButton/>
      <NextItem to='/Work6' thumbnail={thumbnail6} nextProjectTitle='New Outlink-Type Ads'/>
      <div style={{ height: "400px" }} />
      </>
    )
}

export default Work7;
